<div [class.disable-hint]="disableError"
     [class.editable]="editable"
     [class.error]="invalid"
     [class.icon-right]="iconRight"
     [class.icon]="iconName"
     [class.readonly]="readonly"
     [class.table-input]="tableInput"
     [class.unit-text]="textFieldUnitName"
     [class.with-label]="label && iconName"
     [class.with-spin-button]="incrementStep"
     [style.max-width]="maxWidth + 'px'"
     class="work-ui-input-field work-input">
  <div class="work-ui-input-field__header">
    @if (label) {
      <label [for]="id">
        <ng-template #labelContent>
          <b>{{ label | translate }}
            @if (required) {
              <b class="work-text-required-asterisk"> *</b>
            }</b>
        </ng-template>

        @switch (labelSize) {
          @case ('small') {
            <small>
              <ng-container *ngTemplateOutlet="labelContent" />
            </small>
          }
          @case ('default') {
            <p>
              <ng-container *ngTemplateOutlet="labelContent" />
            </p>
          }
        }
      </label>
    }
    @if (!readonly && showMaxLengthCounter && !!maxLength && hasFocus) {
      <div class="work-input__maxlength-hint">
        <small class="work-text-color-light">{{ currentCharLength }}/{{ maxLength }}</small>
      </div>
    }
  </div>
  <div class="input-wrapper">
    @if (variant === 'textField') {
      @if (textFieldUnitName) {
        <span #unitText class="input-wrapper__unit-wrapper">
          <p [innerHTML]="textFieldUnitName" class="input-wrapper__unit"></p>
        </span>
      }
      <input #inputField
             (blur)="onBlur()"
             (focus)="onFocus()"
             (input)="updateValueFromNativeInput()"
             (wheel)="onWheel($event)"
             [attr.autocomplete]="autoComplete ? 'on' : 'work-no-autofill'"
             [attr.id]="id ? id : undefined"
             [class.readonly--no-borders]="readonlyNoBorders"
             [disabled]="disabled || formControl?.disabled"
             [maxLength]="maxLength"
             [max]="max"
             [min]="min"
             [name]="name"
             [placeholder]="placeholder | translate"
             [readOnly]="readonly"
             [required]="required"
             [style.max-width]="maxWidth + 'px'"
             [attr.inputmode]="inputMode ? inputMode : undefined"
             [type]="formattedNumber === null ? type : 'text'"
             [value]="formattedNumber ?? value"
             [step]="incrementStep"
             workUiAutoInitialWidthInputField />
      @if (secretRevealToggle && !readonly) {
        <work-ui-icon (click)="togglePasswordVisibility()" class="input-wrapper__password-toggle"
                      name="visibility_off" />
      }
    }
    @if (variant === 'textarea') {
      <textarea #inputArea
                (blur)="onBlur()"
                (focus)="onFocus()"
                (input)="updateValueFromNativeInput()"
                [attr.autocomplete]="autoComplete ? 'on' : 'work-no-autofill'"
                [attr.rows]="tableInput && rows === nrOfRowsDefault ? 1 : rows"
                [class.full-height]="!setAutoHeight"
                [class.readonly--no-borders]="readonlyNoBorders"
                [disabled]="disabled || formControl?.disabled"
                [id]="id"
                [maxLength]="maxLength"
                [name]="name"
                [placeholder]="placeholder | translate"
                [readOnly]="readonly"
                [required]="required"
                [value]="value"
                [workUiAutoHeightTextareaValue]="value"
                [workUiAutoHeightTextarea]="setAutoHeight"></textarea>
    }
    <work-ui-loading-spinner [(loadingState)]="loadingState" />
    @if (iconName) {
      <work-ui-icon [name]="iconName" />
    }
    @if (shortcutHint && !value && !hasFocus && !readonly) {
      <kbd class="work-ui-input-field__shortcut-hint work-text-color-light">{{ shortcutHint }}</kbd>
    }
    @if (showClearButton && value && !readonly) {
      <div (click)="clear()"
           [class.fade-in]="loadingState === 'none'"
           [class.fade-out]="loadingState !== 'none'"
           class="work-ui-input-field__clear">
        <work-ui-icon name="close" />
      </div>
    }
  </div>

  @if (!!hintMessage && !invalid) {
    <span class="work-input__hint">
      <small class="work-text-color-light">{{ hintMessage | translate }}</small>
    </span>
  }

  @if (!disableError) {
    <span [style.opacity]="invalid ? '1' : '0'" class="work-input__hint">
      <small><b>{{ errorMessage || '-' | translate }}</b></small>
    </span>
  }
</div>
